import http from './http';

/// Gider service

export function getGider() {
    return http.get(`/gider`);
}

export function getGiderDetail(id) {
    return http.get(`/gider/detail/${id}`);
}

export function createGider(data) {
    return http.post(`/gider/create`, data);
}

export function updateGider(id, data) {
    return http.put(`/gider/update/${id}`, data);
}

export function deleteGider(id) {
    return http.delete(`/gider/delete/${id}`);
}
